  function path(root: string, sublink: string) {
    return `${root}${sublink}`;
  }
  
  const ROOTS_AUTH = '/auth';
  const ROOTS_DASHBOARD = '/dashboard';
  
  export const paths = {
    root: '/',
    contact: '/contact-us',
    auth: {
      root: ROOTS_AUTH,
      login: path(ROOTS_AUTH, '/login'),
      register: path(ROOTS_AUTH, '/register'),
      verify: path(ROOTS_AUTH, '/verify'),
      resetPassword: path(ROOTS_AUTH, '/reset-password'),
      newPassword: path(ROOTS_AUTH, '/new-password'),
    },
    dashboard: {     
      root: ROOTS_DASHBOARD,
      player: {
        report: path(ROOTS_DASHBOARD, '/player'),
      },
      profile: {
        root: path(ROOTS_DASHBOARD, '/profile'),
        new: path(ROOTS_DASHBOARD, '/profile/new'),
        view: (id: number) => path(ROOTS_DASHBOARD, `/profile/${id}`),
        edit: (id: number) => path(ROOTS_DASHBOARD, `/profile/${id}/edit`),
        userAdd: (profileId: number) => path(ROOTS_DASHBOARD, `/profile/${profileId}/user/new`),
        ownerAdd: (profileId: number) => path(ROOTS_DASHBOARD, `/profile/${profileId}/owner/new`),
      },
      teams: {
        root: path(ROOTS_DASHBOARD, '/team'),
        new: path(ROOTS_DASHBOARD, '/team/new'),
        view: (id: number) => path(ROOTS_DASHBOARD, `/team/${id}`),
        edit: (id: number) => path(ROOTS_DASHBOARD, `/team/${id}/edit`),
        playerView: (teamId: number, playerId: number) => path(ROOTS_DASHBOARD, `/team/${teamId}/player/${playerId}`),
        playerEdit: (teamId: number, playerId: number) => path(ROOTS_DASHBOARD, `/team/${teamId}/player/${playerId}/edit`),
        playerAdd: (teamId: number) => path(ROOTS_DASHBOARD, `/team/${teamId}/player/new`),
        managerAdd: (teamId: number) => path(ROOTS_DASHBOARD, `/team/${teamId}/manager/new`),
        managerEdit: (teamId: number, managerId: number) => path(ROOTS_DASHBOARD, `/team/${teamId}/manager/${managerId}/edit`),
        register: (id: number) => path(ROOTS_DASHBOARD, `/team/${id}/register`),
        registerStart: path(ROOTS_DASHBOARD, '/team/register'),
      },
      general: {
        account: path(ROOTS_DASHBOARD, '/account'),
        help: path(ROOTS_DASHBOARD, '/help'),
      },
    }
  };
